import StorePlatformContractWorkflowCommonLoader from "../libraries/store-platform-contract-workflow-common-loader"
import platformPlanLoad from '../libraries/platform-plan-load'

const StorePlatformContractController = {
  list() {
    document.addEventListener('DOMContentLoaded', () => {
      Array.from(document.getElementsByName('search')).forEach(el => {
        el.addEventListener('click', (e) => {
          const form_element = el.parentNode.parentNode
          form_element.action = '/manage/store_platform_contracts'
          form_element.submit()
        })
      })
    }, false)
  },

  workflowNew() {
    StorePlatformContractWorkflowCommonLoader()
  },

  workflowCreate() {
    StorePlatformContractWorkflowCommonLoader()
  },

  new() {
    StorePlatformContractWorkflowCommonLoader()
  },

  addToggleHandler() {
    const setupToggle = (selectTarget, formTarget) => {
      const select = document.querySelector(`[data-toggle-target="${selectTarget}"]`)
      const formDiv = document.querySelector(`[data-toggle-target="${formTarget}"]`)
      if (!select || !formDiv) return

      const toggleForm = () => {
        if (select.value === "true") {
          formDiv.classList.remove("hidden")
        } else {
          formDiv.classList.add("hidden")
        }
      }

      toggleForm()

      select.addEventListener("change", toggleForm)
    }

    // AIでんわ
    setupToggle("aiCallSelect", "aiCallForm")

    // コールセンター転送
    setupToggle("aiSupportSelect", "aiSupportForm")

    // SMS送信
    setupToggle("messageSmsSelect", "messageSmsForm")

    // AIメッセージ
    setupToggle("messageLineSelect", "messageLineForm")

    // メッセージ-LINEチャット対応
    setupToggle("messageLineChatSelect", "messageLineChatForm")

    // AIサブカルテ
    setupToggle("subkarteAiSummarySelect", "subkarteAiSummaryForm")

    // サブカルテ-歯式音声入力
    setupToggle("subkarteDentalFormulasVoiceInputSelect", "subkarteDentalFormulasVoiceInputForm")

    // レセコン-OEMレセコン導入
    setupToggle("oemRececomSelect", "oemRececomForm")

  },

  setPlatformPlan() {
    const idEl = document.querySelector(".form-control[name$='[platform_plan_id]']")

    platformPlanLoad(idEl.value, () => {
      StorePlatformContractController.addToggleHandler()
    })
  }
}

window.set_platform_plan = () => {
  StorePlatformContractController.setPlatformPlan()
}

document.addEventListener('DOMContentLoaded', () => {
  StorePlatformContractController.addToggleHandler()
})

export default StorePlatformContractController
